/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jun 09 2023
 **/

import styled from "@emotion/styled";
import { Card } from "@/frameworks/designStuff/components";

interface ImageProps {
	type: "mini" | "large" | "Xlarge" | string | UnitString | undefined;
}
export const Layout = styled(Card.Layout)`
	.space-card__warp {
		transition: filter 0.5s ease-in-out;
	}

	&:hover {
		.space-card__warp {
			filter: blur(2px);
		}
	}
`;
export const Image = styled(Card.Image)<ImageProps>`
	width: 100%;
	display: block;
	margin-top: ${(props) =>
		props.type === "large" ? "-41px" : props.type === "mini" ? "-51px" : props.type === "Xlarge" ? "-12px" : null};
`;
export const Content = styled(Card.Content)`
	box-shadow: 4px;
`;

export const Wrapper = styled.div<ImageProps>`
	width: 100%;
	height: ${(props) =>
		props.type === "mini"
			? "70px"
			: props.type === "large"
				? "102px"
				: props.type === "Xlarge"
					? "190px"
					: props.type};
	overflow: hidden;
	position: relative;
	&::before {
		content: "";
		position: absolute;
		width: inherit;
		height: 52px;
		bottom: 0;
		background: linear-gradient(180deg, rgba(31, 31, 33, 0) 0%, rgba(31, 31, 33, 0.4) 100%);
	}
`;
